import { gql } from '@apollo/client';

// ==================== QUERIES ====================

export const GET_PREDICTIVE_MOD_CONFIG = gql`
  query GetPredictiveModControlConfig {
    getPredictiveModControlConfig {
      id
      enabled
      checkIntervalSeconds
      threshold100Probability
      threshold90Probability
      threshold70Probability
      threshold50Probability
      thresholdBelowProbability
      lastCheckAt
      lastModState
      lastPercentage
      lastProbability
      lastDecision
      lastReason
      lastChangedBy
      lastChangedAt
      createdAt
      updatedAt
    }
  }
`;

export const GET_PREDICTIVE_MOD_STATUS = gql`
  query GetPredictiveModControlStatus {
    getPredictiveModControlStatus {
      enabled
      modEnabled
      currentTaxAmount
      currentTaxTarget
      currentPercentage
      probabilityToActivate
      thresholdLevel
      lastCheckAt
      lastDecision
      lastReason
      checkIntervalSeconds
    }
  }
`;

export const GET_PREDICTIVE_MOD_LOGS = gql`
  query GetPredictiveModControlLogs($limit: Int) {
    getPredictiveModControlLogs(limit: $limit) {
      id
      action
      previousModState
      newModState
      taxPercentage
      probabilityUsed
      randomValue
      decision
      reason
      changedBy
      createdAt
    }
  }
`;

// ==================== MUTATIONS ====================

export const TOGGLE_PREDICTIVE_MOD_CONTROL = gql`
  mutation TogglePredictiveModControl($enabled: Boolean!, $changedBy: String!) {
    togglePredictiveModControl(enabled: $enabled, changedBy: $changedBy) {
      id
      enabled
      checkIntervalSeconds
      threshold100Probability
      threshold90Probability
      threshold70Probability
      threshold50Probability
      thresholdBelowProbability
      lastCheckAt
      lastModState
      lastChangedBy
      lastChangedAt
    }
  }
`;

export const UPDATE_PREDICTIVE_MOD_CONFIG = gql`
  mutation UpdatePredictiveModConfig($input: UpdatePredictiveModConfigInput!) {
    updatePredictiveModConfig(input: $input) {
      id
      enabled
      checkIntervalSeconds
      threshold100Probability
      threshold90Probability
      threshold70Probability
      threshold50Probability
      thresholdBelowProbability
      lastCheckAt
      lastModState
      lastChangedBy
      lastChangedAt
    }
  }
`;

export const CHECK_PREDICTIVE_MOD_STATE = gql`
  mutation CheckPredictiveModState {
    checkPredictiveModState {
      changed
      previousState
      newState
      percentage
      probability
      randomValue
      decision
      reason
    }
  }
`;
